// Shared text input primitive. DESIGN-VISUAL.md §6.4 `--border-control`, §6.8 "inputs 48px tall
// on mobile" (`--space-7` = 48 px, so `h-s7` is that exact token, not a bare number), §3.4 error
// state on `--color-attention`. `:focus-visible` is the global ink ring (T-03); never set
// `outline-none` here.
import type { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export function Input({ invalid = false, className = '', ...rest }: InputProps) {
  return (
    <input
      aria-invalid={invalid || undefined}
      className={[
        'h-s7 w-full rounded-control border bg-paper px-s3 text-body text-ink',
        invalid ? 'border-attention' : 'border-ink-soft',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  );
}
